<template>
  <div class="conversation-item" :class="[{ 'current-user': current, 'conversation-item-event': isEvent }]">
    <div>
      <!-- Message isEvent -->
      <div v-if="isEvent">
        {{ getEventMessage(item) }}
      </div>
      <!-- Message -->
      <div v-else-if="item && (item.message || (item.files && item.files.length))" class="conversation-message-container" :class="[{ 'current-user': current }, { 'item-loading': item.loading }]">
        <span class="conversation-message-date">
          {{ $moment(item.createdAt).format("lll") }}
        </span>
        <template v-if="item && item.message">
          <div class="conversation-message-with-avatar" :class="[{ 'current-user': current }]">
            <div class="conversation-message-avatar">
              <user-avatar :name="item.sender.name" :online="item.sender.online" :avatar="item.sender.avatar" />
            </div>
            <div class="conversation-message">
              <p class="link" v-html="parseMessage(item?.message)" />
            </div>
          </div>
        </template>
        <div v-if="item && item.files && item.files.length > 0" class="conversation-attachment" :class="[{ 'current-user-attachment': current }]">
          <div class="conversation-item-container">
            <!-- <div v-if="item.message" class="conversation-message">
            <p class="link" v-html="parseMessage(item.message)" />
          </div> -->
            <div v-if="item.files && item.files.length" class="conversation-attachment" :class="[{ 'current-user-attachment': current }]">
              <div v-for="uploadFile in item.files" :key="uploadFile.id" class="conversation-attachment-container">
                <template v-if="uploadFile.isImage">
                  <!-- <img
                  :src="getImage(uploadFile, 'medium')"
                  alt=""
                  class="conversation-attachment-image"
                  @click="openImageModal(uploadFile)"
                > -->
                  <b-image
                    ratio="1by1"
                    :src="getImage(uploadFile, 'medium')"
                    class="skeleton-image-placeholder"
                    @click.native="openImageModal(uploadFile)"
                  >
                    <template #placeholder>
                      <b-skeleton />
                    </template>
                  </b-image>
                </template>
                <template v-else>
                  <div
                    class="uploaded-files-container"
                    :style="`background-color: ${getColor(uploadFile.extension).bgColor};`"
                    @click="download(uploadFile)"
                  >
                    <b-button icon-left="download" class="download-button" />
                    <div class="uploaded-files-header">
                      <h3 :style="`color: ${getColor(uploadFile.extension).color}`">
                        {{ uploadFile.name.split('.').pop().toUpperCase() }}
                      </h3>
                    </div>
                    <div class="uploaded-files-body">
                      <p>{{ uploadFile.originalName }}</p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
          <b-modal v-model="isImageModalActive">
            <b-image
              v-if="modalImage"
              :src="modalImage.path"
              class="image-placeholder"
              lazy
            >
              <template #placeholder>
                <b-skeleton />
              </template>
            </b-image>
            <b-button icon-left="download" class="download-button" @click="download(modalImage)" />
          </b-modal>
        <!-- <user-avatar /> -->
        </div>
      </div>
      <!-- Message typing -->
      <div v-else-if="isTyping" class="conversation-message typing">
        <div />
        <div />
        <div />
        <!-- <p class="link">
          <b-icon icon="comments-rated" size="is-small" />
        </p> -->
      </div>
    </div>
  </div>
</template>

<script>
import UserAvatar from '~/marketplace-front-core/components/shared/UserAvatar'

export default {
  name: 'NewMessengerConversationItem',
  components: { UserAvatar },
  props: {
    item: {
      type: Object,
      default: null
    },
    current: {
      type: Boolean,
      default: false
    },
    isTyping: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isImageModalActive: false,
      modalImage: null,
      extensionColors: {
        docx: {
          color: '#46A5EE',
          bgColor: '#C7E4FA'
        },
        doc: {
          color: '#46A5EE',
          bgColor: '#C7E4FA'
        },
        xls: {
          color: '#25A366',
          bgColor: '#A6DAC2'
        },
        xlsx: {
          color: '#25A366',
          bgColor: '#A6DAC2'
        },
        rar: {
          color: '#EAA627',
          bgColor: '#FBDFAC'
        },
        zip: {
          color: '#EAA627',
          bgColor: '#FBDFAC'
        },
        pdf: {
          color: '#E33032',
          bgColor: '#F9D4D4'
        },
        file: {
          color: '#909091',
          bgColor: '#D5D5D5'
        }
      }
    }
  },
  computed: {
    isEvent () {
      return this.item && (this.item.type === 'eventJoined' || this.item.type === 'eventLeft')
    }
  },
  methods: {
    getColor (file) {
      const extension = file.split('.').pop().toLowerCase()
      if (this.extensionColors[extension]) {
        return this.extensionColors[extension]
      } else {
        return this.extensionColors.file
      }
    },
    isSeller () {
      if (this.user) {
        const check = ['ROLE_SELLER_OWNER', 'ROLE_SELLER'].filter(val =>
          this.user.roles.includes(val)
        )

        return check.length
      }
      return false
    },
    getEventMessage (item) {
      if (item.sender && item.assigner && this.isSeller()) {
        const state = item.type === 'eventJoined' ? this.$t('newMessenger.assigned') : this.$t('newMessenger.deleteAssigned')
        const state2 = item.type === 'eventJoined' ? this.$t('newMessenger.toChat') : this.$t('newMessenger.fromChat')

        return item.sender.name + ' ' + state + ' ' + item.assigner.name + ' ' + state2
      }

      if (item.assigner) {
        return item.assigner.name + ' ' + (item.type === 'eventJoined' ? this.$t('newMessenger.eventJoined') : this.$t('newMessenger.eventLeft'))
      }
    },
    parseMessage (message) {
      const regex = /(?:^|[^"'])(https?:\/\/[\S]+)/g
      return message.replace(regex, match => `<a href="${match}" target="_blank">${match}</a>`)
    },
    openImageModal (image) {
      this.modalImage = image
      this.isImageModalActive = true
    },
    getImage (image, size) {
      console.log('getImage:', image.image[size])
      return image.image[size]
    },
    removeExtension (name) {
      return name.substring(0, name.lastIndexOf('.')) || name
    },
    download (file) {
      const link = document.createElement('a')
      link.setAttribute('href', file.path)
      link.setAttribute('target', '_blank')
      link.setAttribute('download', file.originalName)
      link.click()
    }
  }
}
</script>

<style lang="scss" scoped>
$conversationMessageBgColor: #EAEAEA;
$conversationMessageCurrentUserBgColor: $primary;

.conversation-item {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-end;
  align-self: flex-start;
  gap: 8px;
  width: 90%;
  font-size: 14px;

  .conversation-item-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .conversation-message-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    &.current-user {
      align-items: flex-end;
    }
    .conversation-message-date {
      font-size: 12px;
    }
    & + .conversation-attachment {
      margin-top: 10px;
    }
    &.item-loading {
      opacity: 0.6;
    }
  }
  .conversation-message-with-avatar {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    &.current-user {
      flex-direction: row-reverse;
    }
  }
  .conversation-message {
    background-color: $conversationMessageBgColor;
    display: flex;
    flex-wrap: wrap;
    padding: 8px 16px;
    border-radius: 18px;
    width: fit-content;
    &.typing {
      display: flex;
      align-items: center;
      gap: 4px;
      padding: 12px;
      div {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #838383;
        animation-duration: 1s;
        animation-name: typing;
        animation-iteration-count: infinite;
        &:nth-child(2) {
          animation-delay: 0.33s;
        }
        &:nth-child(3) {
          animation-delay: 0.66s;
        }
      }
    }
  }

  &.conversation-item-event {
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  &.current-user {
    flex-direction: row;
    align-self: flex-end;

    .conversation-message {
      background-color: $conversationMessageCurrentUserBgColor;
      color: white;

      :deep(p)>a {
        color: white;
        text-decoration: underline;
      }
    }
  }
}

p.link {
  white-space: break-spaces;
  overflow-wrap: anywhere;
}
.conversation-attachment {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;
  // max-height: 400px;
  &.current-user-attachment {
    justify-content: flex-end;
  }

  .conversation-attachment-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    text-align: center;
    border-radius: 10px;
    cursor: pointer;
    .image {
      width: 100%;
    }
    :deep(img) {
      border-radius: 10px;
    }
    .uploaded-files-container {
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 60px;
      height: 60px;
      text-align: center;
      border-radius: 10px;
      &:hover {
        .download-button {
          display: inline-flex;
        }
      }
      .download-button {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        height: auto;
        border-radius: 10px;
      }
    }
    .uploaded-files-header {
      width: 100%;
      h3 {
        font-size: 14px;
        font-weight: bold;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .uploaded-files-body {
      width: 100%;
      padding: 0 6px;
      p {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 10px;
      }
    }
  }

  .conversation-attachment-image {
    border-radius: 8px;
  }
}

.download-button {
  position: absolute;
  bottom: 16px;
  right: 16px;
  :deep(i) {
    font-size: 1.5rem !important;
  }
}
:deep(.image-placeholder) {
  .b-skeleton {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    .b-skeleton-item {
      height: 100%;
    }
  }
}
// :deep(.image-placeholder) {
//   background-color: rgba(white, 0.2);
// }

@keyframes typing {
  0% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.2;
    transform: scale(0.5);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
